<template>
  <div>
    <div class="hm-headline">
      <span class="headline">{{ headline }}</span>
      <span class="subhead">{{ subhead }}</span>
    </div>
    <el-card>
      <el-form
        label-position="top"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="广告图片">
          <el-upload
            class="upload"
            ref="upload"
            :file-list="fileList"
            :limit="1"
            drag
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :onError="uploadError"
            :onSuccess="uploadSuccess"
            :beforeUpload="beforeAvatarUpload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将图片拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              <span class="mr"
                >(注：只能上传jpg/png文件，且不超过100kb,当进度条后百分比变成对勾上传成功)</span
              >
              <!--  <el-button size="small" size="mini" :disabled="!isUploadSuccess" @click="preview">预览</el-button> -->
            </div>
          </el-upload>
        </el-form-item>
        <div v-show="advUrl !== ''" class="img-wrapper">
          <div class="title">已上传图片</div>
          <div>
            <img :src="advUrl" alt="预览图" />
          </div>
        </div>
        <el-form-item label="广告名称">
          <el-input
            size="small"
            placeholder="请输入内容"
            v-model.trim="ruleForm.name"
            style="width: 600px"
          ></el-input>
        </el-form-item>
        <el-form-item label="广告链接" prop="link">
          <el-input
            size="small"
            placeholder="请输入内容"
            v-model.trim="ruleForm.link"
            style="width: 600px"
          >
            <template slot="append"
              >预置链接</template
            >
          </el-input>
        </el-form-item>
        <el-form-item label="是否开启">
          <el-switch
            v-model="ruleForm.isOpen"
            active-color="#13ce66"
          ></el-switch>
          <span class="form-tip">(注：关闭后手机端不显示)</span>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper text-center">
        <el-button
          size="small"
          type="primary"
          round
          @click="save"
          :loading="isSaving"
          >保存</el-button
        >
        <el-button size="small" round @click="back">返回</el-button>
      </div>
    </el-card>
    <!-- <el-dialog title="预览图" :visible.sync="dialogVisible" width="30%" center>
      <div class="img-wrapper"><img :src="advUrl" alt="预览图"></div>
      <span slot="footer">
         <el-button size="small" type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      advUrl: "",
      isUploadSuccess: false,
      dialogVisible: false,
      id: "",
      headline: "充值管理",
      subhead: "充值列表-设置充值广告",
      ruleForm: {
        name: "",
        link: "",
        isOpen: true
      },
      rules: {
        link: [
          {
            // pattern: /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g,
            message: "请输入正确的网址",
            trigger: "blur"
          }
        ],
        isOpen: []
      }
    };
  },

  components: {},

  created() {
    /**
     * @param type 0 通过充值列表进入
     * @param type 1 通过预约列表进入
     */
    const { type } = this.$route.params;
    if (type === "0") {
      this.$store.dispatch("queryRechargeAdv");
    } else {
      this.headline = "任务管理";
      this.subhead = "广告列表-新增首页广告";
    }
  },

  computed: mapState({
    addRechargeAdvCode: state => state.recharge.addRechargeAdvCode,
    updateRechargeAdvCode: state => state.recharge.updateRechargeAdvCode,
    rechargeAdv: state => state.recharge.rechargeAdv
  }),

  watch: {
    addRechargeAdvCode(val) {
      if (val === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.$router.back();
      }
      this.$store.commit("addRechargeAdv", "");
    },
    updateRechargeAdvCode(val) {
      if (val === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.$router.back();
      }
      this.$store.commit("updateRechargeAdv", "");
    },
    rechargeAdv(val) {
      if (val && val.length > 0) {
        this.ruleForm.name = val[0].name;
        this.ruleForm.link = val[0].link;
        this.advUrl = val[0].imgUrl;
        this.ruleForm.isOpen = val[0].isOpen;
        this.id = val[0].id;
      }
    }
  },

  methods: {
    save() {
      const { type } = this.$route.params;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.advUrl === "") {
            this.$message({
              type: "warning",
              message: "还未选择图片"
            });
          } else {
            if (type === "0") {
              if (this.id !== "") {
                this.$store.dispatch("updateRechargeAdv", {
                  id: this.id,
                  name: this.ruleForm.name,
                  link: this.ruleForm.link,
                  imgUrl: this.advUrl,
                  isOpen: this.ruleForm.isOpen
                });
              } else {
                this.$store.dispatch("addRechargeAdv", {
                  name: this.ruleForm.name,
                  link: this.ruleForm.link,
                  imgUrl: this.advUrl,
                  isOpen: this.ruleForm.isOpen
                });
              }
            } else {
              // 预约管理
            }
          }
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.isUploadSuccess = false;
      this.advUrl = "";
      // this.$message({
      //   type: 'success',
      //   message: '移除成功！'
      // })
    },

    // 预览
    preview() {
      this.dialogVisible = true;
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.advUrl = response.result;
      this.isUploadSuccess = true;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    back() {
      this.$router.back();
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp 格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 100k!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    }
  }
};
</script>
<style lang="scss" scoped>
.form-tip {
  font-size: 12px;
  color: #999;
  margin-left: 0.5rem;
}
.mr {
  margin-right: 2rem;
}

.upload {
  width: 500px;
}
.title {
  font-size: 14px;
  margin-bottom: 10px;
}

.img-wrapper {
  width: 300px;
  margin-bottom: 10px;
  img {
    width: 100%;
  }
}
</style>
